// Mount the Mail module: hand `createMailModule` a lazy host (`./mail-host`, which holds the heavy
// app imports) instead of a built one. `service-modules.ts` and `service-scopes.ts` take the routes
// and the catalog scopes from HERE, so the module cannot be mounted unregistered. This file must
// stay light: it is in the entry chunk. The HTTP client is not a member: the module reads it from
// the shared registry (`@vnetwork/margarita-core/http`).
import { createMailModule } from '@vnetwork/margarita-mail';

export const mail = createMailModule(() => import('./mail-host').then((m) => m.mailHost));
